import Reflux from 'reflux';
import { ExportActions, AppActions } from 'actions';
import SteelCompass from 'services/SteelCompass';

const ExportStore = Reflux.createStore({
  listenables: [ExportActions],
  data: {},

  getInitialState() {
    return this.data;
  },

  exportIncomingPayment(email) {
    this.data.loading = true;
    this.trigger(this.data);
    return SteelCompass.request('payment/incoming', 'export', { recipientEmail: email }).then(
      response => {
        ExportActions.exportIncomingPaymentComplete(response.data);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },

  exportIncomingPaymentComplete(data) {
    AppActions.translatableMessage('transaction.exportDone');
  }
});

export default ExportStore;



// WEBPACK FOOTER //
// ./src/js/stores/Export.js